import { createSelector } from 'reselect';
import { creationOccupationsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const creationOccupationsYearsSelector = createSelector([creationOccupationsSelector], (creationOccupations) =>
  extractDatesFromNestedItems(
    [creationOccupations.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
